import React from 'react';
import AtlasV2TrafficShareSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2TrafficShareSplineChart';

const AtlasV2PaidTrafficShareChart = () => {
  return (
    <AtlasV2TrafficShareSplineChart fieldName="adClicks" title="Share of Paid Traffic" trafficLabel="paid traffic" />
  );
};

export default AtlasV2PaidTrafficShareChart;
